import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    class: {}
  },
  setup(__props: any, { expose: __expose }) {

    const props = __props;

    const scrollContainerRef = ref<HTMLDivElement | null>(null);
    const getScrollElement = () => scrollContainerRef.value;

    __expose({ getScrollElement });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-slot": "table-container",
    class: "relative h-full w-full overflow-auto",
    ref_key: "scrollContainerRef",
    ref: scrollContainerRef
  }, [
    _createElementVNode("table", {
      "data-slot": "table",
      class: _normalizeClass(_unref(cn)('w-full caption-bottom text-sm', props.class))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 512))
}
}

})